import { BODY_SM_SM_MEDIUM_STYLES, BODY_SM_SM_STYLES } from '@constants/text.ts';
import styled, { css } from 'styled-components';

export const StepWrapper = styled.div`
    display: flex;
    padding: var(--spacing-md, 24px);
    flex-direction: column;
    align-items: stretch;
    align-self: stretch;
    border-radius: var(--border-radius-s_8, 8px);
    border: 1px solid var(--colors-border-primary, #e2e8f0);
    background: var(--colors-surface-primary, #fff);
    margin-bottom: var(--spacing-sm, 16px);
    flex: 1;

    .ant-input {
        color: var(--colors-text-filled, #2f3449);
        ${BODY_SM_SM_STYLES};
    }

    .ant-input::placeholder {
        color: var(--colors-text-on-disabled, #70768d);
    }
`;

export const ADD_BUTTON_OVERRIDDEN_STYLES = css`
    button.ant-btn {
        border-radius: var(--border-radius-s_8, 8px);
        border: var(--border-width-sm_1, 1px) solid rgba(33, 113, 198, 0.4);
        background: var(--colors-surface-page, #e7f4ff);

        span {
            color: var(--colors-text-action, #2171c6);
            ${BODY_SM_SM_MEDIUM_STYLES};
        }

        span.ant-btn-icon {
            margin-top: 4px;
        }

        svg path[stroke] {
            stroke: var(--colors-text-action, #2171c6);
        }

        &:hover,
        &:active,
        &:focus {
            border: var(--border-width-sm_1, 1px) solid rgba(33, 113, 198, 0.4) !important;
            background: var(--colors-surface-page, #e7f4ff) !important;

            span {
                color: var(--colors-text-action, #2171c6);
            }

            svg path[stroke] {
                stroke: var(--colors-text-action, #2171c6);
            }
        }
    }
`;

export const SubmitButtonWrapper = styled.div<{ $marginTop: number; $width: string; $marginBottom?: number }>`
    margin-top: ${({ $marginTop }) => $marginTop}px;
    margin-bottom: ${({ $marginBottom = 0 }) => $marginBottom}px;
    width: ${({ $width }) => $width};
    text-align: end;

    button {
        width: 88px;

        span {
            ${BODY_SM_SM_MEDIUM_STYLES};
        }
    }
`;

// hide validation messages
export const TableNoValidationMSGWrapper = styled.div`
    .ant-form-item-explain,
    .ant-form-item-extra {
        display: none;
    }
`;
